<template>
  <el-dialog
    :close-on-click-modal="false"
    :title="type === 'equip' ? '引用检查项目' : '引用作业步骤'"
    :visible.sync="showDialog"
    width="1280px"
    top="2vh"
    class="large-dialog"
    append-to-body
    v-dialogDrag
  >
    <div class="flex items-center">
      <el-input
        type="text"
        class="mr-10px !w-50"
        clearable
        v-model="searchData.keyword"
        size="small"
        placeholder="请输入关键字"
      />
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
    </div>
    <el-table
      ref="tables"
      :height="tableHeight"
      :data="tableData"
      border
      stripe
      class="mt-20px"
      v-loading="tableLoading"
      @selection-change="handleSelection"
    >
      <el-table-column :selectable="isDisabled" type="selection" width="50"></el-table-column>
      <el-table-column
        v-if="type === 'equip'"
        label="检查项目"
        prop="projectName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="type === 'equip'"
        label="检查标准"
        prop="standard"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="type === 'equip'"
        label="不符合标准情况"
        prop="noComplianceStandard"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="type === 'equip'"
        label="主要后果"
        prop="consequences"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        v-if="type === 'job'"
        label="作业步骤"
        prop="jobStep"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="type === 'job'"
        label="危险源或潜在事件"
        prop="hiddenEvent"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        v-if="type === 'job'"
        label="危险有害因素分类"
        prop="harmElementType"
        show-overflow-tooltip
      ></el-table-column>

      <el-table-column
        v-if="type === 'job'"
        label="可能导致事故类型"
        prop="accidentType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="是否重点管控" prop="isFocusControl" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.isFocusControl === 0 || scope.row.isFocusControl === '0'">否</span>
          <span v-else-if="scope.row.isFocusControl === 1 || scope.row.isFocusControl === '1'"
            >是</span
          >
          <span v-else></span>
        </template>
      </el-table-column>
      <el-table-column
        v-if="type === 'equip'"
        label="详情位置"
        prop="location"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="财产伤亡预测"
        prop="assetsCasualtyPredict"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="searchList"
      @current-change="findList"
      :current-page.sync="pageNo"
      :page-size.sync="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="total"
      class="float-right mt-20px ml-10px"
    ></el-pagination>
    <div slot="footer" class="text-center">
      <el-button type="primary" size="small" @click="handleOk()" icon="iconfont icon-save">
        <span>确定</span>
      </el-button>
      <el-button size="small" @click="showDialog = false" icon="iconfont icon-close">
        <span>取消</span>
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import utils from '@/components/safety/enumField/utils'
import {
  SourcesDangerEquipmentFacilityCheckProjectApi,
  SourcesDangerJobActivityStepApi,
} from '@wiz-api/double-prevention-management'

const sourcesDangerEquipmentFacilityCheckProjectApi = new SourcesDangerEquipmentFacilityCheckProjectApi()
const sourcesDangerJobActivityStepApi = new SourcesDangerJobActivityStepApi()

export default {
  name: 'select-check-items',
  props: {
    values: {
      default: () => {
        return []
      },
    },
    type: {
      default: 'equip',
    },
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 15,
      total: 0,
      searchForm: {},
      currentSelectRowId: '',
      keyword: '',
      searchData: {
        keyword: '',
      },
      tableData: [],
      showDialog: false,
      pageTotal: 0,
      currentSelectRow: null,
      tableLoading: false,
      selectionData: [],
    }
  },
  watch: {
    showDialog(bol) {
      if (bol) {
        this.searchList()
        return
      }
      this.keyword = ''
      this.currentSelectRowId = ''
      this.currentSelectRow = null
    },
    selectRows(list) {
      if (!this.$refs.tables) {
        return
      }
      this.$refs.tables.clearSelection()
      this.$nextTick(() => {
        list.forEach((item) => {
          this.$refs.tables.toggleRowSelection(item)
        })
      })
    },
  },
  computed: {
    selectRows() {
      return this.tableData.filter((item) => {
        return this.values.indexOf(item.id) > -1
      })
    },
    tableHeight() {
      return 'calc(100% - 110px)'
    },
  },
  methods: {
    // 禁用复选框 0禁用 1不禁用
    isDisabled(row) {
      if (this.values.indexOf(row.id) > -1) {
        return 0
      }
      return 1
    },
    handleSelection(values) {
      this.selectionData = values
    },
    handleOk() {
      this.$emit('handleOk', this.selectionData)
      this.showDialog = false
    },

    async findList() {
      this.tableLoading = true
      const searchData = utils.deleteFormField(this.searchData)
      const data = {
        skipCount: (this.pageNo - 1) * this.pageSize,
        maxResultCount: this.pageSize,
        ...searchData,
      }
      // const [err, res] =
      // this.type === 'equip'
      //   ? await equipmentFacilitySourcesDangerIdentifyApi.getRefCheckProjectPageList(data)
      //   : await jobSourcesDangerIdentifyApi.getRefCheckProjectPageList(data)
      const [err, res] =
        this.type === 'equip'
          ? await sourcesDangerEquipmentFacilityCheckProjectApi.pagedListQuery(data)
          : await sourcesDangerJobActivityStepApi.pagedListQuery(data)

      if (!err) {
        this.tableData = res.items
        this.total = res.totalCount
        this.tableLoading = false
      }
    },
    searchList() {
      this.pageNo = 1
      this.findList()
    },
  },
  created() {
    this.findList()
  },
}
</script>

<style lang="scss" scoped></style>
